import { render, staticRenderFns } from "./listado_pedidos_asesor.vue?vue&type=template&id=52321030&scoped=true"
import script from "./listado_pedidos_asesor.vue?vue&type=script&lang=js"
export * from "./listado_pedidos_asesor.vue?vue&type=script&lang=js"
import style0 from "./listado_pedidos_asesor.vue?vue&type=style&index=0&id=52321030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52321030",
  null
  
)

export default component.exports